module.exports = __webpack_public_path__ + "static/media/designPatent_3.72589864.png";